export default __webpack_public_path__ + "static/media/tick-icon-filled.996379e6.svg";